import { render, staticRenderFns } from "./snakeDetails.vue?vue&type=template&id=1b563db6"
import script from "./snakeDetails.vue?vue&type=script&lang=js"
export * from "./snakeDetails.vue?vue&type=script&lang=js"
import style0 from "./snakeDetails.vue?vue&type=style&index=0&id=1b563db6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports